import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { updateOrderParam } from "features/hublink/core/tei-hub-link.param";
import {
  GetTeiHubLinkDispatchOrderResponse,
  GetTeiHubLinkDispatchOrderRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkDispatchOrder {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkDispatchOrder;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkDispatchOrder.initial,
  message: "",
};

export const teiHubLinkDispatchOrder = createAsyncThunk(
  "teiHubLinkDispatchOrder",
  async (param: updateOrderParam, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkDispatchOrderResponse =
        await GetTeiHubLinkDispatchOrderRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkDispatchOrderSlice = createSlice({
  name: "teiHubLinkDispatchOrder",
  initialState,
  reducers: {
    resetTeiHubLinkDispatchOrder: (state) => {
      state.status = TeiHubLinkDispatchOrder.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkDispatchOrder.pending, (state) => {
        state.status = TeiHubLinkDispatchOrder.inProgress;
      })
      .addCase(teiHubLinkDispatchOrder.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkDispatchOrder.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkDispatchOrder.rejected, (state, action) => {
        state.status = TeiHubLinkDispatchOrder.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkDispatchOrder = (state: RootState) =>
  state.teiHubLinkDispatchOrder;

export const { resetTeiHubLinkDispatchOrder } =
  teiHubLinkDispatchOrderSlice.actions;
export default teiHubLinkDispatchOrderSlice.reducer;
